import React from 'react';
import { Paper } from '@mui/material';

function AdminSection({ children, sx = {}, ...props }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 4,
        p: { xs: 2, md: 3 },
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
}

export default AdminSection;
